import { render } from "./CommunityProjects.vue?vue&type=template&id=54c3dad4&scoped=true"
import script from "./CommunityProjects.vue?vue&type=script&lang=js"
export * from "./CommunityProjects.vue?vue&type=script&lang=js"

import "./CommunityProjects.vue?vue&type=style&index=0&id=54c3dad4&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src1919945302/src/app.tamildata.org/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54c3dad4"]])

export default __exports__